import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";
import RetrieveHostedPCIInfo from "emun.order/retrieve-hostedpci-info";
import modals from "webmodals/modals";
import OrderEnterCreditcard from "emun.order/order-enter-creditcard";
import resolve from 'ioc/resolve'

export default class ProcessPaymentController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.orderId = options.id;
		$ctrl.title = options.title || "Process Payment";
		$ctrl.transactionType = "sale";
	}
	$onInit() {
		const $ctrl = this;
		$ctrl.loadOrder();
		resolve("$rootScope").$on("creditcardChanged", () => {
			$ctrl.loadOrder();
		});
	}
	loadOrder() {
		let $ctrl = this;
		console.debug("BL*** in loadOrder");
		$ctrl.bus.send("QueryCarts.json?Id=" + $ctrl.orderId).then((res) => {
			if (res.data.results.length) $ctrl.order = res.data.results[0];
			$ctrl.request = {
				VendorId: $ctrl.order.vendorId,
				Token: $ctrl.order.paymentMethod.id,
				RetailerId: $ctrl.order.retailerId,
				OrderNumber: $ctrl.order.id,
				MerchantRefId: ""
			};
			$ctrl.request.orderAmount = $ctrl.order.grandTotal;
			$ctrl.request.otherCharges = 0;
			$ctrl.payments = new AutoQuery({
				url: "HostedPCI/QueryPayments?OrderNumber=" + $ctrl.order.id,
				orderBy: "transactionDate",
				autoLoad: true
			});
			$ctrl.bus.send("QueryVendors.json?Id=" + $ctrl.order.vendorId).then((res) => {
				if (res.data.results) {
					$ctrl.vendor = res.data.results[0];
					if ($ctrl.vendor.settings.filter( s=> s.key == "ProcessPaymentsTransaction").length) $ctrl.transactionType = $ctrl.vendor.settings.filter( s=> s.key == "ProcessPaymentsTransaction")[0].value;
				}
			});
		});
	}
	enterCreditCard() {
		let $ctrl = this;
		return OrderEnterCreditcard({ orderId: $ctrl.order.id });
	}
	retrieveHostedPCIInfo(token, expiration, cvv) {
		let $ctrl = this;
		return RetrieveHostedPCIInfo({ token: $ctrl.order.paymentMethod.token, expiration: $ctrl.order.paymentMethod.expiration, cvv: "" });
	}
	processPayment() {
		let $ctrl = this;
		$ctrl.request.Amount = $ctrl.request.orderAmount + $ctrl.request.otherCharges;
		return modals.confirm("Process payment in the amount of $" + $ctrl.request.Amount, "Process Payment").result.then(function () {
			$ctrl.bus.send(`HostedPCI/Gateway${$ctrl.transactionType == "sale" ? "Sale" : "Authorize"}.json`, $ctrl.request).then((res) => {
				if (res.data.status == "success") {
					modals.alert("Transaction processed succesfully");
				} else {
					modals.alert(res.data.gatewayResponseCode + " - " + res.data.gatewayResponseStatus)
				}
				$ctrl.payments.load(true);
			});
		});

	}
}
